const fs = require('fs') //引入文件系统模块
const path = require('path') //引入path模块
// axios
import axios from '@/axios'
import { resolve } from 'path'
//读取json文件
function getJsonFile(filePath) {
  //读取指定json文件
  var json = fs.readFileSync(path.resolve(__dirname, filePath), 'utf-8')
  //解析并返回
  return JSON.parse(json)
}

const urlToStr = {
  _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

  // private method for UTF-8 encoding
  _utf8_encode(string) {
    string = string.replace(/\r\n/g, '\n')
    var utftext = ''
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  },

  // private method for UTF-8 decoding
  _utf8_decode(utftext) {
    var string = ''
    var i = 0
    var c = 0,
      c2 = 0,
      c3 = 0
    while (i < utftext.length) {
      c = utftext.charCodeAt(i)
      if (c < 128) {
        string += String.fromCharCode(c)
        i++
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1)
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        string += String.fromCharCode(
          ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        )
        i += 3
      }
    }
    return string
  },

  xjdtostring(str) {
    if (str.indexOf('/') != -1) {
      str = str.replace('/', 'XieGan')
    }
    if (str.indexOf('+') != -1) {
      str = str.replace('+', 'JiaHao')
    }
    if (str.indexOf('=') != -1) {
      str = str.replace('=', 'DenYuHao')
    }
    return str
  },
  stringtoxjd(str) {
    if (str.indexOf('XieGan') != -1) {
      str = str.replace('XieGan', '/')
    }
    if (str.indexOf('JiaHao') != -1) {
      str = str.replace('JiaHao', '+')
    }
    if (str.indexOf('DenYuHao') != -1) {
      str = str.replace('DenYuHao', '=')
    }
    return str
  },
  encrypt(input) {
    var output = ''
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4
    var i = 0
    input = this._utf8_encode(input)
    while (i < input.length) {
      chr1 = input.charCodeAt(i++)
      chr2 = input.charCodeAt(i++)
      chr3 = input.charCodeAt(i++)
      enc1 = chr1 >> 2
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      enc4 = chr3 & 63
      if (isNaN(chr2)) {
        enc3 = enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }
      output =
        output +
        this._keyStr.charAt(enc1) +
        this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) +
        this._keyStr.charAt(enc4)
    }

    return this.xjdtostring(output)
  },
  decrypt(input) {
    input = this.stringtoxjd(input)
    var output = ''
    var chr1, chr2, chr3
    var enc1, enc2, enc3, enc4
    var i = 0
    // eslint-disable-next-line no-useless-escape
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')
    while (i < input.length) {
      enc1 = this._keyStr.indexOf(input.charAt(i++))
      enc2 = this._keyStr.indexOf(input.charAt(i++))
      enc3 = this._keyStr.indexOf(input.charAt(i++))
      enc4 = this._keyStr.indexOf(input.charAt(i++))
      chr1 = (enc1 << 2) | (enc2 >> 4)
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
      chr3 = ((enc3 & 3) << 6) | enc4
      output = output + String.fromCharCode(chr1)
      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2)
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3)
      }
    }

    output = this._utf8_decode(output)
    return output
  },
}

// 检测字符串是否为空或者超出限定字数
function checkStrNullOrTooLong(strs = [], config = {}) {
  var defaultConfig = {
      INPUT_MAX_LENGTH: 50, // 输入最长 50 字符
      nullable: false, // 是否可空
    },
    isInputTooLong = false,
    isNull = false,
    message = {
      isInputTooLong: '项目命名输入不能超过 50 字！',
      isNull: '项目命名不能为空',
    }

  defaultConfig = Object.assign(defaultConfig, config)

  // 是否需要检测是否为空
  if (!defaultConfig.nullable) {
    isNull = strs.some((item) => {
      return !item || item.length === 0
    })
    if (isNull) {
      this.$message({
        message: message.isNull,
        type: 'error',
        duration: 2000,
      })

      return isNull
    }
  }
  // 如果非空，再进行检查超长
  if (!isNull) {
    isInputTooLong = strs.some(
      (item) => item && item.length > defaultConfig.INPUT_MAX_LENGTH
    )
    if (isInputTooLong) {
      this.$message({
        message: message.isInputTooLong,
        type: 'error',
        duration: 2000,
      })

      return isInputTooLong
    }
  }

  // 如果不通过返回一个 true
  return isInputTooLong || isNull
}

// 检测字符串是否为空或者超出限定字数
function checkStrNullOrTooLongData(strs = [], config = {}) {
  var defaultConfig = {
      INPUT_MAX_LENGTH: 50, // 输入最长 50 字符
      nullable: false, // 是否可空
    },
    isInputTooLong = false,
    isNull = false,
    message = {
      isInputTooLong: '数据集名称输入不能超过 50 字！',
      isNull: '数据集名称不能为空',
    }

  defaultConfig = Object.assign(defaultConfig, config)

  // 是否需要检测是否为空
  if (!defaultConfig.nullable) {
    isNull = strs.some((item) => {
      return !item || item.length === 0
    })
    if (isNull) {
      this.$message({
        message: message.isNull,
        type: 'error',
        duration: 2000,
      })

      return isNull
    }
  }
  // 如果非空，再进行检查超长
  if (!isNull) {
    isInputTooLong = strs.some(
      (item) => item && item.length > defaultConfig.INPUT_MAX_LENGTH
    )
    if (isInputTooLong) {
      this.$message({
        message: message.isInputTooLong,
        type: 'error',
        duration: 2000,
      })

      return isInputTooLong
    }
  }

  // 如果不通过返回一个 true
  return isInputTooLong || isNull
}

// 浏览器兼容性
function browserCompatibility() {
  var userAgent = navigator.userAgent
  var browserName = navigator.appName
  var fullVersion = '' + parseFloat(navigator.appVersion)
  var majorVersion = parseInt(navigator.appVersion, 10)
  var nameOffset, verOffset, ix
  // In Opera 15+, the true version is after "OPR/"
  if ((verOffset = userAgent.indexOf('OPR/')) != -1) {
    browserName = 'Opera'
    fullVersion = userAgent.substring(verOffset + 4)
  }
  // In older Opera, the true version is after "Opera" or after "Version"
  else if ((verOffset = userAgent.indexOf('Opera')) != -1) {
    browserName = 'Opera'
    fullVersion = userAgent.substring(verOffset + 6)
    if ((verOffset = userAgent.indexOf('Version')) != -1)
      fullVersion = userAgent.substring(verOffset + 8)
  }
  // In IE MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset = userAgent.indexOf('MSIE')) != -1) {
    browserName = 'Microsoft Internet Explorer'
    fullVersion = userAgent.substring(verOffset + 5)
  }
  // In IE Trident, the true version is after "Trident/" in userAgent
  else if ((verOffset = userAgent.indexOf('Trident/')) != -1) {
    verOffset = userAgent.indexOf('rv:')
    browserName = 'Microsoft Internet Explorer'
    fullVersion = userAgent.substring(verOffset + 3)
  }
  // In IE Edge, the true version is after "Edge/" in userAgent
  else if ((verOffset = userAgent.indexOf('Edge/')) != -1) {
    browserName = 'Edge'
    fullVersion = userAgent.substring(verOffset + 5)
  }
  // In Chrome, the true version is after "Chrome"
  else if ((verOffset = userAgent.indexOf('Chrome')) != -1) {
    browserName = 'Chrome'
    fullVersion = userAgent.substring(verOffset + 7)
  }
  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset = userAgent.indexOf('Safari')) != -1) {
    browserName = 'Safari'
    fullVersion = userAgent.substring(verOffset + 7)
    if ((verOffset = userAgent.indexOf('Version')) != -1)
      fullVersion = userAgent.substring(verOffset + 8)
  }
  // In Firefox, the true version is after "Firefox"
  else if ((verOffset = userAgent.indexOf('Firefox')) != -1) {
    browserName = 'Firefox'
    fullVersion = userAgent.substring(verOffset + 8)
  }
  // In most other browsers, "name/version" is at the end of userAgent
  else if (
    (nameOffset = userAgent.lastIndexOf(' ') + 1) <
    (verOffset = userAgent.lastIndexOf('/'))
  ) {
    browserName = userAgent.substring(nameOffset, verOffset)
    fullVersion = userAgent.substring(verOffset + 1)
    if (browserName.toLowerCase() == browserName.toUpperCase()) {
      browserName = navigator.appName
    }
  }
  // trim the fullVersion string at semicolon/space if present
  if ((ix = fullVersion.indexOf(';')) != -1)
    fullVersion = fullVersion.substring(0, ix)
  if ((ix = fullVersion.indexOf(' ')) != -1)
    fullVersion = fullVersion.substring(0, ix)
  majorVersion = parseInt('' + fullVersion, 10)
  if (isNaN(majorVersion)) {
    fullVersion = '' + parseFloat(navigator.appVersion)
    majorVersion = parseInt(navigator.appVersion, 10)
  }
  fullVersion = fullVersion.replace(/[(),]/g, '')
  // var browserInfo = browserName + "/" + majorVersion + "/" + fullVersion;
  var browserInfo = {
    browserName: browserName,
    majorVersion: majorVersion,
    fullVersion: fullVersion,
  }
  return browserInfo
}

// 上传格式检测
function formatCheck(fileName, suffix) {
  return RegExp('(' + suffix + ')$').test(fileName)
}

function filesFormatCheck(files, suffix) {
  var fileList

  if (Array.isArray(files)) {
    fileList = files
  } else if (typeof files === 'object') {
    fileList = [files]
  } else {
    throw Error('请输出数组或者单文件对象格式！')
  }

  // 排除了不存在的
  let flng = fileList.every((f) => {
    let name = f.name.toLowerCase()
    return formatCheck(name, suffix)
  })
  return !flng

  // 排除了不存在的
  // return fileList.some((f) => {
  //   let name = f.name.toLowerCase()
  //   !formatCheck(name, suffix)
  // })
}
/**
 * 检测每一个上传的文件格式
@param files 文件列表
@param reg 正则表达
*/
function filesFormatEveryCheck(files, reg) {
  var fileList
  if (Array.isArray(files)) {
    fileList = files
  } else if (typeof files === 'object') {
    fileList = [files]
  } else {
    throw Error('请输出数组或者单文件对象格式！')
  }
  return fileList.every((f) => reg.test(f.name))
}

//颜色转换器转成rgba
function getColor(hex, opacity) {
  return (
    'rgba(' +
    parseInt('0x' + hex.slice(1, 3)) +
    ',' +
    parseInt('0x' + hex.slice(3, 5)) +
    ',' +
    parseInt('0x' + hex.slice(5, 7)) +
    ',' +
    opacity +
    ')'
  )
}
//颜色转换器转成rgba
function foramtStr(str) {
  try {
    let obj = JSON.parse(str)
    return JSON.stringify(obj, null, '\t')
  } catch (e) {
    return str
  }
}

// 文件大小处理
/**
 *
 * @param { number } fileSize 文件大小
 * @param { number } shortLen 数字截断保留位数，默认 2
 */
function fileSizeTranfor(fileSize, shortLen) {
  let size = fileSize / (1024 * 1024),
    unit = 'M'

  if (size < 1) {
    size = fileSize / 1024
    unit = 'K'
  } else if (size > 1024) {
    size = fileSize / (1024 * 1024 * 1024)
    unit = 'G'
  }

  size = size.toFixed(shortLen ? shortLen : 2)

  return size + unit
}

/**
 * 创建 a 标签进行链接下载
 * @param { string } fileUrl 下载链接
 * @param { string } fileName  文件名称
 */
function createDownload(fileUrl, fileName) {
  var a = document.createElement('a')
  a.href = fileUrl
  a.setAttribute('download', fileName)
  a.click()
  a = null
}

const tokenExpressInTime = () => {
  let date = new Date()
  let tokenTime = localStorage.getItem('tokenTime')
  // 当前时间减去获取本地过期时间的值是否大于0   大于0为过期返回true 否则返回false
  return date.getTime() - Number(tokenTime) > 0 ? true : false
}

//生成uuid
function generateUUID() {
  var d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() //use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
    c
  ) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return uuid
}

// clearRect清空画布
function clearCanvas(dom) {
  var cxt = dom.getContext('2d')
  let width = dom.width
  dom.width = width
  cxt.clearRect(0, 0, dom.width, dom.height)
}

//缓存代理函数
const getCacheProxy = (fn, cache = new Map()) => {
  return new Proxy(fn, {
    apply(target, context, args) {
      const argsString = args.join(' ')
      if (cache.has(argsString)) {
        // 如果有缓存,直接返回缓存数据
        // console.log(`输出${args}的缓存结果: ${cache.get(argsString)}`)
        return cache.get(argsString)
      }
      const result = fn(...args)
      cache.set(argsString, result)

      return result
    },
  })
}
//转换媒体的url --适配旧的生产环境建的积木编辑器的工作台的图片/音频/文本积木的url适配
const exchangeMediaDomain = (url, domain) => {
  if(!domain) return url
  let bucket = '/aishixun'
  // let urlArr = undefined
  // let http_match = /(http|https):\/\//g
  // var getHttps = http_match.exec(url)
  // if (getHttps.length > 1) {
  //   urlArr = url.split(bucket)
  //   url = domain + bucket + urlArr[1]
  // }
  url = domain + bucket + url.split(bucket)[1];
  return url
}

//检测电脑设备是否已经安装了摄像头
function getCamera() {
  sessionStorage.cameraFlag = true;

	if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
		// Firefox 38+ seems having support of enumerateDevicesx
		navigator.enumerateDevices = function(callback) {
			navigator.mediaDevices.enumerateDevices().then(callback);
		};
	}
	var MediaDevices = [];
	var isHTTPs = location.protocol === 'https:';
	var canEnumerate = false;

	if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
		canEnumerate = true;
	} else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
		canEnumerate = true;
	}

	var hasMicrophone = false;
	var hasSpeakers = false;
	var hasWebcam = false;

	var isMicrophoneAlreadyCaptured = false;
	var isWebcamAlreadyCaptured = false;

	function checkDeviceSupport(callback) {
		if (!canEnumerate) {
			return;
		}

		if (!navigator.enumerateDevices && window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
			navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
		}

		if (!navigator.enumerateDevices && navigator.enumerateDevices) {
			navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
		}

		if (!navigator.enumerateDevices) {
			if (callback) {
				callback();
			}
			return;
		}

		MediaDevices = [];
		navigator.enumerateDevices(function(devices) {
			devices.forEach(function(_device) {
				var device = {};
				for (var d in _device) {
					device[d] = _device[d];
				}

				if (device.kind === 'audio') {
					device.kind = 'audioinput';
				}

				if (device.kind === 'video') {
					device.kind = 'videoinput';
				}

				var skip;
				MediaDevices.forEach(function(d) {
					if (d.id === device.id && d.kind === device.kind) {
						skip = true;
					}
				});

				if (skip) {
					return;
				}

				if (!device.deviceId) {
					device.deviceId = device.id;
				}

				if (!device.id) {
					device.id = device.deviceId;
				}

				if (!device.label) {
					device.label = 'Please invoke getUserMedia once.';
					if (!isHTTPs) {
						device.label = 'HTTPs is required to get label of this ' + device.kind + ' device.';
					}
				} else {
					if (device.kind === 'videoinput' && !isWebcamAlreadyCaptured) {
						isWebcamAlreadyCaptured = true;
					}

					if (device.kind === 'audioinput' && !isMicrophoneAlreadyCaptured) {
						isMicrophoneAlreadyCaptured = true;
					}
				}

				if (device.kind === 'audioinput') {
					hasMicrophone = true;
				}

				if (device.kind === 'audiooutput') {
					hasSpeakers = true;
				}

				if (device.kind === 'videoinput') {
					hasWebcam = true;
				}

				// there is no 'videoouput' in the spec.

				MediaDevices.push(device);
			});

			if (callback) {
				callback();
			}
		});
	}
	//end

  checkDeviceSupport(function() {
    if(hasWebcam == false){
      sessionStorage.cameraFlag = false;
  		console.log("没有摄像头！");
  		return false;
  	}else{
  		if(isWebcamAlreadyCaptured == false){
        sessionStorage.cameraFlag = false;
  			console.log("捕获摄像头失败，请重新安装摄像头！");
  			return false;
  		}
  	}
  	if(hasMicrophone == false){
  		console.log("没有麦克风！");
  		return false;
  	}else{
  		if(isMicrophoneAlreadyCaptured == false){
  			console.log("捕获麦克风失败，请重新安装麦克风！");
  			return false;
  		}
  	}
  });

}

export default {
  getJsonFile,
  urlToStr,
  checkStrNullOrTooLong,
  checkStrNullOrTooLongData,
  browserCompatibility,
  formatCheck,
  filesFormatCheck,
  filesFormatEveryCheck,
  fileSizeTranfor,
  createDownload,
  getColor: getColor,
  tokenExpressInTime,
  generateUUID,
  clearCanvas,
  foramtStr,
  // getTxtContent,
  exchangeMediaDomain,
  getCamera,
}
